export default __webpack_public_path__ + "static/map/img/def_points.8ac3c92.png";